(() => {
  const isMovaraProduct = () => {
    const handle = window.meta?.product?.handle;
    return handle === 'coolza-movara' || window.location.pathname === '/products/coolza-movara';
  };

  if (!isMovaraProduct()) return;

  let timer = null;

  const bundleCaret = 'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23363636%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E")';

  const ensureStyle = () => {
    const css = [
      '#MainContent pagepilot-product-price .pp-compare-at-price,#MainContent .pp-product-price .pp-compare-at-price,#MainContent pagepilot-product-price .pp-savings,#MainContent .pp-product-price .pp-savings{display:none!important;}',
      '#MainContent .kaching-bundles__bar-variant-select{box-sizing:border-box!important;width:auto!important;min-width:82px!important;max-width:100%!important;min-height:32px!important;margin:0!important;padding:5px 24px 5px 0!important;border:0!important;border-radius:4px!important;background-color:transparent!important;background-image:' + bundleCaret + '!important;background-repeat:no-repeat!important;background-position:right 2px center!important;background-size:16px 16px!important;color:#172026!important;font:inherit!important;font-size:15px!important;font-weight:500!important;line-height:1.25!important;letter-spacing:0!important;appearance:none!important;-webkit-appearance:none!important;box-shadow:none!important;}',
      '#MainContent .kaching-bundles__bar-variant-select::-ms-expand{display:none!important;}',
      '#MainContent .kaching-bundles__bar-variant-select:focus{outline:2px solid rgba(0,175,185,.55)!important;outline-offset:2px!important;}',
      '#MainContent .cz-movara-single-purchase{display:none!important;}'
    ].join('');

    let style = document.getElementById('cz-movara-single-support-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'cz-movara-single-support-style';
      document.head.append(style);
    }
    if (style.textContent !== css) style.textContent = css;
  };

  const removeStaleSingleControls = () => {
    document.querySelectorAll('#MainContent .cz-movara-single-purchase').forEach((element) => element.remove());
  };

  const syncPrice = () => {
    const priceRoot = document.querySelector('#MainContent pagepilot-product-price, #MainContent .pp-product-price');
    if (!priceRoot) return;
    const price = priceRoot.querySelector('.pp-price');
    const compare = priceRoot.querySelector('.pp-compare-at-price');
    const savings = priceRoot.querySelector('.pp-savings');
    if (price) price.textContent = '$24.95 USD';
    if (compare) {
      compare.textContent = '';
      compare.setAttribute('aria-hidden', 'true');
      compare.style.display = 'none';
    }
    if (savings) {
      savings.textContent = '';
      savings.setAttribute('aria-hidden', 'true');
      savings.style.display = 'none';
    }
  };

  const apply = () => {
    ensureStyle();
    removeStaleSingleControls();
    syncPrice();
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(apply, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  setTimeout(apply, 300);
  setTimeout(apply, 1000);
  setTimeout(apply, 2200);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', apply);
})();
